const API_TYPE = {
    STENCIL_DISPLAY: '/StencilDisplay/',
    TEMPLATES: '/Template/',
    GROUPS: '/TemplateGroup/',
    FIELDS: '/TemplateDataField/',
    FIELD_TYPES: '/TemplateDataFieldType/',
    SETTINGS: '/TemplateSettings/',
    ADMIN_SETTINGS: '/TemplateAdminSettings/',
    USER: '/User/'
}

const buildApiUrl = (type) => {
    const portalAliasElement = document.getElementById('hdnStencilDisplaySettingsPortalAlias')
    const portalAlias = portalAliasElement ? portalAliasElement.value : null
    return `${location.protocol}//${portalAlias ? portalAlias : location.hostname}/DesktopModules/StencilDisplay/API${type}`
}

export const getModuleId = () => {
    const moduleIdElement = document.getElementById('hdnStencilDisplaySettingsModuleId')
    return moduleIdElement ? moduleIdElement.value : null
};

//Data Field Controller
export const GET_ALL_DATA_FIELDS_BY_TEMPLATE_ID_URL = () => {
    return buildApiUrl(API_TYPE.FIELDS) + 'GetAllDataFieldsByTemplateId?id='
};

//Data Field Type Controller
export const GET_ALL_FIELD_TYPES_URL = () => {
    return buildApiUrl(API_TYPE.FIELD_TYPES) + 'GetAllFieldTypes'
};

//Template Controller
export const GET_ALL_TEMPLATES_BY_GROUP_ID_URL = () => {
    return buildApiUrl(API_TYPE.TEMPLATES) + 'GetAllTemplatesByGroupId?id='
};
export const GET_TEMPLATES_BY_ID_URL = () => {
    return buildApiUrl(API_TYPE.TEMPLATES) + 'GetTemplateById?id='
};

//Template Settings Controller
export const GET_TEMPLATE_PREVIEW_DATA_URL = () => {
    return buildApiUrl(API_TYPE.SETTINGS) + 'GetTemplatePreviewDataByTemplateId?id='
};
export const GET_ALL_PAGES_URL = () => {
    return buildApiUrl(API_TYPE.SETTINGS) + 'GetAllPortalPageNamesAndUrls'
};

//Template Group Controller
export const GET_ALL_GROUPS_URL = () => {
    return buildApiUrl(API_TYPE.GROUPS) + 'GetAllGroups'
};

//Template Display Controller
export const SAVE_TEMPLATE_DATA_URL = () => {
    return buildApiUrl(API_TYPE.STENCIL_DISPLAY) + 'SaveTemplateData'
};
export const LOAD_TEMPLATE_DATA_URL = () => {
    return buildApiUrl(API_TYPE.STENCIL_DISPLAY) + 'LoadTemplateData?moduleId='
};

//Template Admin Settings Controller
export const GET_TEMPLATE_EXAMPLE_MODULE_ID = () => {
    return `${buildApiUrl(API_TYPE.ADMIN_SETTINGS)}GetTemplateExampleModuleId?templateId=`;
};
export const UPDATE_TEMPLATE_EXAMPLE_URL = () => {
    return `${buildApiUrl(API_TYPE.ADMIN_SETTINGS)}UpdateTemplateExample`;
};

//User Controller
export const IS_SUPER_USER_URL = () => {
    return `${buildApiUrl(API_TYPE.USER)}IsSuperUser`;
};

//STRINGS
export const AdminPanelStrings = {
    title: 'Display Settings',
    templateMenuLabel: 'Choose Template',
    fieldDataMenuLabel: 'Template Field Data',
    adminMenuLabel: 'Admin Settings',
    phoneNumber: '0333 577 7776'
}

export const ValidationStrings = {
    description: 'Template display settings have not been saved:'
}

export const MessageStrings = {
    onSaveSuccess: 'Template display settings have been saved!',
    onSaveError: 'An error occurred when saving. Please try again later',
    noGroupsFound: 'No Template Groups were found.'
}

export const SaveTemplatePopUpStrings = {
    title: 'Confirm',
    message: 'Are you sure you want to save this Template ?',
    cancelButton: 'Cancel',
    saveButton: 'Save'
}

export const ChangeTemplatePopUpStrings = {
    title: 'Confirm',
    message: 'Are you sure you want to change this Template?',
    subMessage: '(This will clear any unsaved data)',
    cancelButton: 'No',
    saveButton: 'Yes'
}

export const AssetManagerPopUpStrings = {
    title: 'Choose Asset',
    cancelButton: 'Cancel',
    saveButton: 'Save'
}

export const ListManagerPopUpStrings = {
    editTitle: 'Edit List Entry',
    addTitle: 'Add New List Entry',
    cancelButton: 'Cancel',
    saveButton: 'Save'
}

export const SaveTemplateButton = {
    text: 'Save Template'
}

export const LivePreviewStrings = {
    header: 'Preview',
    noPreviewData: 'No Preview Data available',
    refreshPreview: 'Refresh Preview',
    expandPreview: 'Show Full-Sized Preview'
}

export const TemplateGroupStrings = {
    header: 'Template Group',
    placeholder: 'Choose a template group',
    noGroupsPlaceholder: 'No Template Groups Found'
}

export const TemplateStrings = {
    header: 'Template',
    placeholder: 'Choose a template',
    noTemplatesPlaceholder: 'No Templates Found',
    warning: 'Please Note: Choosing new template will clear data fields.',
    previewHeader: 'Sample Template',
    noPreviewData: 'No Preview Data Found',
    expandPreview: 'Click to see full width'
}

export const FieldDataStrings = {
    header: 'Data Field Model',
    add: '+ Add Model',
    noTemplatesPlaceholder: 'Please choose a template',
    noListPlaceholder: 'No List Template Data Found',
    placeholder: 'Enter Field',
    textField: 'Text',
    htmlField: 'Html',
    linkField: 'Link',
    checkboxField: 'Checkbox',
    assetField: 'Asset',
    dropdownField: 'Dropdown',
    listField: 'List',
    dateField: 'Date',
    dateTimeField: 'Date/Time',
    noFieldOptionsPlaceholder: 'No Options Found',
    optionsPlaceholder: 'Choose an option',
    noPagesPlaceholder: 'No Pages found',
    pagesPlaceholder: 'Choose a page',
    searchPlaceholder: 'Search...',
    selectAssetButton: 'Select Asset',
    changeAssetButton: 'Change Asset',
    clearAssetButton: 'Clear Asset',
    externalUrlText: 'Use external URL?',
    deleteModel: 'Delete Model'
}

export const FieldDataListStrings = {
    addEntry: '+ Add Entry',
    listEntryNameHeader: 'Field Name',
    listEntryValueHeader: 'Field Value',
    expandList: '[+ Expand List]',
    collapseList: '[- Collapse List]',
    noData: 'No Valid Data',
    editEntry: 'Edit Entry',
    expandEntry: 'Expand Entry',
    collapseEntry: 'Collapse Entry',
    deleteEntry: 'Delete Entry'
}

export const AdminSettingsStrings = {
    header: 'Admin Settings',
    saveSettingsButton: 'Save Settings',
    exampleTitle: 'Use template data as an example:'
}
